import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import AdviceTimelinePageStore from '../store/AdviceTimelinePageStore';
import arrowLeft from '../../../assets/image/arrowleft.png';

import { ConfigProvider, Switch } from 'antd';
import timelineIcon from '../../../assets/image/timeline.png';

import menuIcon from '../../../assets/image/menuIcon.png';
import { useMediaQueryState } from '../../../hooks/useMediaQueryState';

interface TopHeaderProps {
  isBackIcon?: boolean;
  isChangeIcon?: boolean;
  pageStore: AdviceTimelinePageStore;
}

function TopHeader({ isBackIcon, isChangeIcon, pageStore }: TopHeaderProps) {
  const navigate = useNavigate();
  const { isMobile } = useMediaQueryState();
  const handleClickArrowBtn = () => {
    navigate(-1);
  };

  const onClickChangeIcon = () => {
    console.log(pageStore.isChecked);
    pageStore.setIsChecked(!pageStore.isChecked);
  };

  return (
    <Grid container alignItems={'center'} justifyContent={'space-around'} style={{ marginTop: '30px' }}>
      <Grid style={{ marginTop: '6px', cursor: 'pointer' }}>{isMobile && isBackIcon ? <img src={arrowLeft} onClick={handleClickArrowBtn} alt='backIcon' /> : <></>}</Grid>
      <Grid>
        <Typography
          style={{
            fontFamily: 'Pretendard',
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: '24px',
          }}
        >
          Summary
        </Typography>
        {/* <HeaderTitle /> */}
      </Grid>
      <Grid>
        {isChangeIcon ? (
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: '#2281D0',
              },
            }}
          >
            <Switch
              checkedChildren={
                <>
                  <img src={timelineIcon} alt='timeline' />
                </>
              }
              unCheckedChildren={
                <>
                  <img src={menuIcon} alt='menuIcon' />
                </>
              }
              checked={pageStore.isChecked}
              onChange={onClickChangeIcon}
              style={{
                background: '#2281D0',
              }}
            />
          </ConfigProvider>
        ) : (
          <></>
        )}
      </Grid>
    </Grid>
  );
}

export default TopHeader;
